'use strict'

export const copy = (() => {
    const init = () => {
        const copyButtons = document.querySelectorAll('.copy-text__button');
        
        copyButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                const container = button.closest('.copy-text__container');
                const contentElement = container.querySelector('.copy-text__content');
                const textToCopy = contentElement.innerText.trim();
                const originalText = button.innerHTML;

                navigator.clipboard.writeText(textToCopy).then(() => {
                    button.disabled = true;
                    button.innerHTML = 'Gekopieerd naar jouw klembord!';

                    setTimeout(() => {
                        button.innerHTML = originalText;
                        button.disabled = false;
                    }, 2000);
                });
            });
        });
    }

    return {
        init
    }
})();   